import automotiveSassModule from './sprite-automotive.module.scss';
const AUTOMOTIVE = JSON.parse(automotiveSassModule.SPRITE_LIST);

import integrationsSassModule from './sprite-integration.module.scss';
const INTEGRATIONS = JSON.parse(integrationsSassModule.SPRITE_LIST);

import platformsSassModule from './sprite-platform.module.scss';
const PLATFORMS = JSON.parse(platformsSassModule.SPRITE_LIST);

import partnersSassModule from './sprite-partners.module.scss';
const PARTNERS = JSON.parse(partnersSassModule.SPRITE_LIST);

import socialsSassModule from './sprite-social.module.scss';
const SOCIALS = JSON.parse(socialsSassModule.SPRITE_LIST);

import solutionsSassModule from './sprite-solutions.module.scss';
const SOLUTIONS = JSON.parse(solutionsSassModule.SPRITE_LIST);

const PLUGINS = [
    'auro_3d',
    'gme',
    'mcdsp',
    'rev',
    'izotope_reverb',
    'izotope_trash',
    'dolby_atmos',
];

const COMMUNITY_PLUGINS = [
    'atmoky-ears',
    'lkc-grim-sync',
    'oculus-spatializer',
    'polyspectral',
    'resonance',
    'spectral',
];

const AK_PLUGINS = [
    'ak-asio',
    'ak-channel-router',
    'compressor',
    'convolution-reverb',
    'delay-plugin',
    'expander',
    'flanger',
    'gain',
    'guitar-distortion',
    'harmonizer',
    'impacter',
    'mastering-suite',
    'meter',
    'motion',
    'parametric-eq',
    'peak-limiter',
    'pitch-shifter',
    'recorder',
    'reflect',
    'roomverb',
    'silence',
    'sine',
    'soundseed-air',
    'soundseed-grain',
    'stereo-delay',
    'synth-one',
    'threed-bed-audio-mixer',
    'time-stretch',
    'tone-generator',
    'tremolo',
    'matrix-reverb',
];

function goodSprite(spriteId: AllSprites) {
    const allSprites = new Set([
        ...AUTOMOTIVE,
        ...PLATFORMS,
        ...PARTNERS,
        ...INTEGRATIONS,
        ...PLUGINS,
        ...COMMUNITY_PLUGINS,
        ...AK_PLUGINS,
        ...SOCIALS,
        ...SOLUTIONS,
    ]);

    return allSprites.has(spriteId as string);
}

type AutomotiveType = (typeof AUTOMOTIVE)[keyof typeof AUTOMOTIVE];
type PlatformsType = (typeof PLATFORMS)[keyof typeof PLATFORMS];
type PartnersType = (typeof PARTNERS)[keyof typeof PARTNERS];
type IntegrationsType = (typeof INTEGRATIONS)[keyof typeof INTEGRATIONS];
type PluginsType = (typeof PLUGINS)[keyof typeof PLUGINS];
type AkPluginsType = (typeof AK_PLUGINS)[keyof typeof AK_PLUGINS];
type SocialsType = (typeof SOCIALS)[keyof typeof SOCIALS];
type SolutionsType = (typeof SOLUTIONS)[keyof typeof SOLUTIONS];
type AllSprites =
    | AutomotiveType
    | PlatformsType
    | PartnersType
    | IntegrationsType
    | PluginsType
    | AkPluginsType
    | SocialsType
    | SolutionsType;

export {
    // Defined in each module.scss file
    AUTOMOTIVE,
    INTEGRATIONS,
    PLATFORMS,
    PARTNERS,
    SOCIALS,
    SOLUTIONS,

    // HardCoded in this files
    PLUGINS,
    COMMUNITY_PLUGINS,
    AK_PLUGINS,

    // Functions
    goodSprite,

    //Types
    type AutomotiveType,
    type PlatformsType,
    type PartnersType,
    type IntegrationsType,
    type PluginsType,
    type AkPluginsType,
    type SocialsType,
    type SolutionsType,
    type AllSprites,
};
